// extracted by mini-css-extract-plugin
export default {"becomeVendorPage":"style_becomeVendorPage__dB5WH","becomeVendorInner":"style_becomeVendorInner__64wun","loaderBox":"style_loaderBox__-EwiA","successBox":"style_successBox__aHZFR"};